module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAABISURBVEhL7cyxCQAADAJB91866W1ugOTA6sG826bW1EkH6qQDddKBOulAnXSgTjpQJx2okw7USQfqpAN10oE66UCddKD+bkgWwiZvkelZ0CwAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/icons8-pause-24.png
// module id = 913
// module chunks = 1